import { c as _c } from "react/compiler-runtime";
import { type BackendProductResponse, EventEnum } from "@sprawdzonabron/shared";
import { BsShopWindow } from "react-icons/bs";
import { GiSilverBullet } from "react-icons/gi";
import { LuCircleDollarSign } from "react-icons/lu";
import { MdLocationOn } from "react-icons/md";
import { TestIdEnum } from "../../../tests/types";
import { useAnalyticsEvent } from "../../api/hooks/useAnalyticsEvent";
import dayjs from "../../utils/dayjs";
import { formatPrice } from "../../utils/numbers";
import { AvailabilityInfo } from "./AvailabilityInfo";
interface ProductCardProps {
  product: BackendProductResponse;
}
export const ProductCard = t0 => {
  const $ = _c(53);
  const {
    product
  } = t0;
  const postClickEvent = useAnalyticsEvent(EventEnum.ProductClick);
  let t1;
  if ($[0] !== product.name) {
    t1 = <div className="flex justify-between items-start gap-3 mb-2"><h3 className="text-sm font-bold text-slate-800 dark:text-slate-100 leading-tight line-clamp-2" title={product.name} data-testid={TestIdEnum.ProductName}>{product.name}</h3></div>;
    $[0] = product.name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `Producent: ${product.producer}`;
  let t3;
  if ($[2] !== product.producer || $[3] !== t2) {
    t3 = <span className="font-bold text-brand-600 uppercase tracking-wider" title={t2} data-testid={TestIdEnum.ProductProducer}>{product.producer}</span>;
    $[2] = product.producer;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `Sklep: ${product.shop.name}`;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <BsShopWindow />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== product.shop.name || $[7] !== t4) {
    t6 = <div className="flex items-center text-slate-500 dark:text-slate-400"><span title={t4} className="flex items-center gap-1 bg-slate-100 dark:bg-slate-800 px-2 py-0.5 rounded border border-slate-200 dark:border-slate-700" data-testid={TestIdEnum.ProductShop}>{t5} {product.shop.name}</span></div>;
    $[6] = product.shop.name;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t6) {
    t7 = <div className="flex items-center justify-between mb-3 text-xs">{t3}{t6}</div>;
    $[9] = t3;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = `Miasto: ${product.shop.locations[0].city}`;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <MdLocationOn />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== product.shop.locations[0].city || $[14] !== t8) {
    t10 = <span title={t8} className="flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium bg-slate-50 dark:bg-slate-900 text-slate-600 dark:text-slate-400 border border-slate-100 dark:border-slate-700 font-mono" data-testid={TestIdEnum.ProductCity}>{t9} {product.shop.locations[0].city}</span>;
    $[13] = product.shop.locations[0].city;
    $[14] = t8;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = `Kaliber: ${product.caliber}`;
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <GiSilverBullet />;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== product.caliber || $[18] !== t11) {
    t13 = <span title={t11} className="flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium bg-slate-50 dark:bg-slate-900 text-slate-600 dark:text-slate-400 border border-slate-100 dark:border-slate-700 font-mono" data-testid={TestIdEnum.ProductCaliber}>{t12} {product.caliber}</span>;
    $[17] = product.caliber;
    $[18] = t11;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t10 || $[21] !== t13) {
    t14 = <div className="flex flex-wrap gap-1.5 mb-3 mt-auto">{t10}{t13}</div>;
    $[20] = t10;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <LuCircleDollarSign />;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== product.price.value) {
    t16 = product.price.value ? <>{formatPrice(product.price.value)}{" "}<span className="text-xs font-normal text-slate-500">zł</span></> : "Brak ceny";
    $[24] = product.price.value;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t16) {
    t17 = <div className="flex gap-1">{t15}<div className="flex gap-1 items-end text-lg font-bold text-slate-900 dark:text-white font-mono leading-none" data-testid={TestIdEnum.ProductPrice}>{t16}</div></div>;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== product.available) {
    t18 = <AvailabilityInfo availability={product.available} />;
    $[28] = product.available;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t17 || $[31] !== t18) {
    t19 = <div className="flex items-end gap-1">{t17}{t18}</div>;
    $[30] = t17;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== product.price.lastUpdate) {
    t20 = product.price.lastUpdate && <div className="text-xs text-slate-400 dark:text-slate-500">Aktualizacja: {dayjs(product.price.lastUpdate).fromNow()}</div>;
    $[33] = product.price.lastUpdate;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t19 || $[36] !== t20) {
    t21 = <div className="flex flex-col gap-1">{t19}{t20}</div>;
    $[35] = t19;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  const t22 = `Zobacz ofertę dla ${product.name} w sklepie ${product.shop.name}`;
  let t23;
  if ($[38] !== postClickEvent || $[39] !== product.url) {
    t23 = () => postClickEvent(product.url);
    $[38] = postClickEvent;
    $[39] = product.url;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== product.url || $[42] !== t22 || $[43] !== t23) {
    t24 = <div className="flex items-center gap-2"><a href={product.url} target="_blank" rel="noopener noreferrer" title={t22} className="px-4 py-2 bg-slate-900 dark:bg-slate-100 text-white dark:text-slate-900 text-xs font-bold uppercase tracking-wide rounded-lg hover:bg-brand-600 dark:hover:bg-brand-500 hover:text-white dark:hover:text-white transition-colors shadow-sm" onClick={t23} data-testid={TestIdEnum.ProductLink}>Idź do sklepu</a></div>;
    $[41] = product.url;
    $[42] = t22;
    $[43] = t23;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== t21 || $[46] !== t24) {
    t25 = <div className="pt-4 border-t border-slate-100 dark:border-slate-800 flex items-center justify-between mt-auto">{t21}{t24}</div>;
    $[45] = t21;
    $[46] = t24;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== t1 || $[49] !== t14 || $[50] !== t25 || $[51] !== t7) {
    t26 = <article className="group relative flex flex-col bg-white dark:bg-slate-850 rounded-xl border border-slate-200 dark:border-slate-800 transition-all duration-300 hover:shadow-tactical hover:-translate-y-1 hover:border-brand-400 dark:hover:border-brand-600 p-4 h-full" data-testid={TestIdEnum.ProductCard}>{t1}{t7}{t14}{t25}</article>;
    $[48] = t1;
    $[49] = t14;
    $[50] = t25;
    $[51] = t7;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  return t26;
};